// extracted by mini-css-extract-plugin
export var editInput = "_fs-0";
export var editInputCompact = "_fs-2";
export var editInputLarge = "_fs-1";
export var editInputSmall = "_fs-3";